import React, { Component } from 'react';
import { nodeAttrs, windowAttrs } from '../../utils/dom';
import { sendAnalyticsEvent } from '../../utils/analytics';
import { dataLayerPushSendScrollDepthEvent } from '../../utils/dataLayer';
import getDisplayName from '../../utils/getDisplayName';
import {map, set, throttle} from 'lodash';

const defaults = {
  shouldTrackScrollEvent: () => true
};

export default (options = {}) => (WrappedComponent) => class extends Component {
  static displayName =
    `WithScrollDepthTracking(${getDisplayName(WrappedComponent)})`;

  constructor(props, context) {
    super(props, context);
    this.state = {
      scrollDepth: {
        quarter: false,
        half: false,
        threeQuarters: false,
        end: false
      }
    };
    Object.assign(this, defaults, options);
    this.handleScroll = throttle(this.handleScroll.bind(this), 1000);
  }

  componentDidMount() {
    if (this.shouldTrackScrollEvent()) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentDidUpdate() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.shouldTrackScrollEvent()) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const scrollDepthPercent = getScrollDepthPercentForDomNode(this._node);
    const breakpoints = { quarter: 25, half: 50, threeQuarters: 75, end: 100 };

    map(breakpoints, (percent, breakpoint) => {
      const { scrollDepth } = this.state;

      if (scrollDepth[breakpoint]) {
        return;
      }

      if (scrollDepthPercent >= percent) {
        const newScrollDepthState = set({ ...scrollDepth }, breakpoint, true);
        this.setState({ scrollDepth: newScrollDepthState });
        sendAnalyticsEvent('Scroll Depth', 'Scroll', `${percent}%`);
        dataLayerPushSendScrollDepthEvent(['Scroll Depth', 'Scroll', `${percent}%`]);

        // Remove listener after firing last depth event
        if (breakpoint === 'end') {
          window.removeEventListener('scroll', this.handleScroll);
        }
      }
    });
  }

  render() {
    return (
      <div ref={(node) => this._node = node}>
        <WrappedComponent {...this.props} />
      </div>
    );
  }
};

function getScrollDepthPercentForDomNode(node) {
  const { top, bottom } = nodeAttrs(node);
  const { innerHeight, scrollTop } = windowAttrs();
  const pxDepthIntoArticle = innerHeight - top;
  const pxLengthOfArticle = bottom + scrollTop - innerHeight;
  return pxDepthIntoArticle / pxLengthOfArticle * 100;
}
